package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Iraq Flag (16x12dp)
 *
 * - ISO Alpha-2: IQ
 * - ISO Alpha-3: IRQ
 * - ISO Numeric: 368
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Iraq: ImageVector by lazy {
    ImageVector.Builder(
        name = "Iraq:IQ:IRQ:368:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFBF2714)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(4f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 8f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(8f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF009C4E)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.668f, 6.406f)
                curveTo(3.123f, 7.058f, 2.5f, 7.5f, 2.5f, 7.5f)
                curveTo(2.5f, 7.5f, 3.045f, 7.5f, 3.253f, 7.063f)
                horizontalLineTo(7.712f)
                verticalLineTo(6.1f)
                curveTo(7.712f, 6.1f, 7.619f, 5.637f, 7.222f, 5.637f)
                curveTo(6.825f, 5.637f, 6.735f, 6.1f, 6.735f, 6.1f)
                horizontalLineTo(5.167f)
                lineTo(6.684f, 4.76f)
                lineTo(6.389f, 4.5f)
                lineTo(4.704f, 5.988f)
                verticalLineTo(6.303f)
                horizontalLineTo(7.097f)
                verticalLineTo(6.118f)
                curveTo(7.097f, 6.118f, 7.11f, 6.01f, 7.222f, 6.01f)
                curveTo(7.334f, 6.01f, 7.306f, 6.118f, 7.306f, 6.118f)
                verticalLineTo(6.514f)
                horizontalLineTo(4.291f)
                verticalLineTo(5.972f)
                lineTo(3.965f, 6.118f)
                verticalLineTo(6.514f)
                curveTo(3.965f, 6.514f, 3.565f, 6.406f, 3.312f, 6.406f)
                curveTo(3.06f, 6.406f, 3.045f, 6.118f, 3.045f, 6.118f)
                lineTo(2.668f, 6.406f)
                close()
                moveTo(8.723f, 6.443f)
                lineTo(8.968f, 7.052f)
                horizontalLineTo(7.995f)
                verticalLineTo(4.607f)
                lineTo(8.405f, 4.739f)
                verticalLineTo(6.443f)
                horizontalLineTo(8.723f)
                close()
                moveTo(13.255f, 6.443f)
                lineTo(13.5f, 7.052f)
                horizontalLineTo(12.527f)
                verticalLineTo(4.607f)
                lineTo(12.937f, 4.739f)
                verticalLineTo(6.443f)
                horizontalLineTo(13.255f)
                close()
                moveTo(12.051f, 4.632f)
                lineTo(11.797f, 4.804f)
                verticalLineTo(6.441f)
                horizontalLineTo(11.539f)
                verticalLineTo(5.128f)
                lineTo(11.114f, 5.373f)
                verticalLineTo(6.441f)
                horizontalLineTo(10.828f)
                verticalLineTo(5.7f)
                lineTo(10.505f, 5.908f)
                verticalLineTo(6.109f)
                curveTo(10.505f, 6.109f, 9.883f, 6.152f, 9.883f, 7.031f)
                horizontalLineTo(12.048f)
                lineTo(12.051f, 4.632f)
                close()
                moveTo(3.746f, 7.483f)
                curveTo(3.824f, 7.483f, 3.888f, 7.427f, 3.888f, 7.358f)
                curveTo(3.888f, 7.289f, 3.824f, 7.233f, 3.746f, 7.233f)
                curveTo(3.668f, 7.233f, 3.604f, 7.289f, 3.604f, 7.358f)
                curveTo(3.604f, 7.427f, 3.668f, 7.483f, 3.746f, 7.483f)
                close()
                moveTo(10.957f, 4.821f)
                curveTo(10.847f, 4.966f, 10.514f, 4.821f, 10.514f, 4.821f)
                lineTo(11.46f, 4.711f)
                curveTo(11.362f, 4.902f, 10.957f, 4.821f, 10.957f, 4.821f)
                close()
            }
            path(fill = SolidColor(Color(0xFF009C4E))) {
                moveTo(2.5f, 7.5f)
                lineTo(2.355f, 7.296f)
                lineTo(1.715f, 7.75f)
                horizontalLineTo(2.5f)
                verticalLineTo(7.5f)
                close()
                moveTo(2.668f, 6.406f)
                lineTo(2.516f, 6.207f)
                lineTo(2.327f, 6.352f)
                lineTo(2.463f, 6.549f)
                lineTo(2.668f, 6.406f)
                close()
                moveTo(3.253f, 7.063f)
                verticalLineTo(6.813f)
                horizontalLineTo(3.096f)
                lineTo(3.028f, 6.955f)
                lineTo(3.253f, 7.063f)
                close()
                moveTo(7.712f, 7.063f)
                verticalLineTo(7.313f)
                horizontalLineTo(7.962f)
                verticalLineTo(7.063f)
                horizontalLineTo(7.712f)
                close()
                moveTo(7.712f, 6.1f)
                horizontalLineTo(7.962f)
                verticalLineTo(6.075f)
                lineTo(7.957f, 6.05f)
                lineTo(7.712f, 6.1f)
                close()
                moveTo(6.735f, 6.1f)
                verticalLineTo(6.35f)
                horizontalLineTo(6.942f)
                lineTo(6.981f, 6.147f)
                lineTo(6.735f, 6.1f)
                close()
                moveTo(5.167f, 6.1f)
                lineTo(5.002f, 5.912f)
                lineTo(4.506f, 6.35f)
                horizontalLineTo(5.167f)
                verticalLineTo(6.1f)
                close()
                moveTo(6.684f, 4.76f)
                lineTo(6.85f, 4.948f)
                lineTo(7.062f, 4.76f)
                lineTo(6.85f, 4.573f)
                lineTo(6.684f, 4.76f)
                close()
                moveTo(6.389f, 4.5f)
                lineTo(6.555f, 4.313f)
                lineTo(6.389f, 4.167f)
                lineTo(6.224f, 4.313f)
                lineTo(6.389f, 4.5f)
                close()
                moveTo(4.704f, 5.988f)
                lineTo(4.539f, 5.8f)
                lineTo(4.454f, 5.875f)
                verticalLineTo(5.988f)
                horizontalLineTo(4.704f)
                close()
                moveTo(4.704f, 6.303f)
                horizontalLineTo(4.454f)
                verticalLineTo(6.553f)
                horizontalLineTo(4.704f)
                verticalLineTo(6.303f)
                close()
                moveTo(7.097f, 6.303f)
                verticalLineTo(6.553f)
                horizontalLineTo(7.347f)
                verticalLineTo(6.303f)
                horizontalLineTo(7.097f)
                close()
                moveTo(7.097f, 6.118f)
                lineTo(6.848f, 6.087f)
                lineTo(6.847f, 6.102f)
                verticalLineTo(6.118f)
                horizontalLineTo(7.097f)
                close()
                moveTo(7.306f, 6.118f)
                lineTo(7.064f, 6.056f)
                lineTo(7.056f, 6.086f)
                verticalLineTo(6.118f)
                horizontalLineTo(7.306f)
                close()
                moveTo(7.306f, 6.514f)
                verticalLineTo(6.764f)
                horizontalLineTo(7.556f)
                verticalLineTo(6.514f)
                horizontalLineTo(7.306f)
                close()
                moveTo(4.291f, 6.514f)
                horizontalLineTo(4.041f)
                verticalLineTo(6.764f)
                horizontalLineTo(4.291f)
                verticalLineTo(6.514f)
                close()
                moveTo(4.291f, 5.972f)
                horizontalLineTo(4.541f)
                verticalLineTo(5.586f)
                lineTo(4.189f, 5.744f)
                lineTo(4.291f, 5.972f)
                close()
                moveTo(3.965f, 6.118f)
                lineTo(3.863f, 5.889f)
                lineTo(3.715f, 5.955f)
                verticalLineTo(6.118f)
                horizontalLineTo(3.965f)
                close()
                moveTo(3.965f, 6.514f)
                lineTo(3.899f, 6.755f)
                lineTo(4.215f, 6.841f)
                verticalLineTo(6.514f)
                horizontalLineTo(3.965f)
                close()
                moveTo(3.045f, 6.118f)
                lineTo(3.294f, 6.105f)
                lineTo(3.27f, 5.63f)
                lineTo(2.893f, 5.919f)
                lineTo(3.045f, 6.118f)
                close()
                moveTo(8.968f, 7.052f)
                verticalLineTo(7.302f)
                horizontalLineTo(9.338f)
                lineTo(9.2f, 6.958f)
                lineTo(8.968f, 7.052f)
                close()
                moveTo(8.723f, 6.443f)
                lineTo(8.955f, 6.349f)
                lineTo(8.892f, 6.193f)
                horizontalLineTo(8.723f)
                verticalLineTo(6.443f)
                close()
                moveTo(7.995f, 7.052f)
                horizontalLineTo(7.745f)
                verticalLineTo(7.302f)
                horizontalLineTo(7.995f)
                verticalLineTo(7.052f)
                close()
                moveTo(7.995f, 4.607f)
                lineTo(8.071f, 4.369f)
                lineTo(7.745f, 4.265f)
                verticalLineTo(4.607f)
                horizontalLineTo(7.995f)
                close()
                moveTo(8.405f, 4.739f)
                horizontalLineTo(8.655f)
                verticalLineTo(4.556f)
                lineTo(8.481f, 4.5f)
                lineTo(8.405f, 4.739f)
                close()
                moveTo(8.405f, 6.443f)
                horizontalLineTo(8.155f)
                verticalLineTo(6.693f)
                horizontalLineTo(8.405f)
                verticalLineTo(6.443f)
                close()
                moveTo(13.5f, 7.052f)
                verticalLineTo(7.302f)
                horizontalLineTo(13.87f)
                lineTo(13.732f, 6.958f)
                lineTo(13.5f, 7.052f)
                close()
                moveTo(13.255f, 6.443f)
                lineTo(13.488f, 6.349f)
                lineTo(13.425f, 6.193f)
                horizontalLineTo(13.255f)
                verticalLineTo(6.443f)
                close()
                moveTo(12.527f, 7.052f)
                horizontalLineTo(12.277f)
                verticalLineTo(7.302f)
                horizontalLineTo(12.527f)
                verticalLineTo(7.052f)
                close()
                moveTo(12.527f, 4.607f)
                lineTo(12.603f, 4.369f)
                lineTo(12.277f, 4.265f)
                verticalLineTo(4.607f)
                horizontalLineTo(12.527f)
                close()
                moveTo(12.937f, 4.739f)
                horizontalLineTo(13.187f)
                verticalLineTo(4.556f)
                lineTo(13.014f, 4.5f)
                lineTo(12.937f, 4.739f)
                close()
                moveTo(12.937f, 6.443f)
                horizontalLineTo(12.687f)
                verticalLineTo(6.693f)
                horizontalLineTo(12.937f)
                verticalLineTo(6.443f)
                close()
                moveTo(11.797f, 4.804f)
                lineTo(11.657f, 4.597f)
                lineTo(11.547f, 4.671f)
                verticalLineTo(4.804f)
                horizontalLineTo(11.797f)
                close()
                moveTo(12.051f, 4.632f)
                lineTo(12.301f, 4.633f)
                lineTo(12.301f, 4.161f)
                lineTo(11.911f, 4.425f)
                lineTo(12.051f, 4.632f)
                close()
                moveTo(11.797f, 6.441f)
                verticalLineTo(6.691f)
                horizontalLineTo(12.047f)
                verticalLineTo(6.441f)
                horizontalLineTo(11.797f)
                close()
                moveTo(11.539f, 6.441f)
                horizontalLineTo(11.289f)
                verticalLineTo(6.691f)
                horizontalLineTo(11.539f)
                verticalLineTo(6.441f)
                close()
                moveTo(11.539f, 5.128f)
                horizontalLineTo(11.789f)
                verticalLineTo(4.695f)
                lineTo(11.414f, 4.912f)
                lineTo(11.539f, 5.128f)
                close()
                moveTo(11.114f, 5.373f)
                lineTo(10.989f, 5.157f)
                lineTo(10.864f, 5.229f)
                verticalLineTo(5.373f)
                horizontalLineTo(11.114f)
                close()
                moveTo(11.114f, 6.441f)
                verticalLineTo(6.691f)
                horizontalLineTo(11.364f)
                verticalLineTo(6.441f)
                horizontalLineTo(11.114f)
                close()
                moveTo(10.828f, 6.441f)
                horizontalLineTo(10.578f)
                verticalLineTo(6.691f)
                horizontalLineTo(10.828f)
                verticalLineTo(6.441f)
                close()
                moveTo(10.828f, 5.7f)
                horizontalLineTo(11.078f)
                verticalLineTo(5.242f)
                lineTo(10.693f, 5.49f)
                lineTo(10.828f, 5.7f)
                close()
                moveTo(10.505f, 5.908f)
                lineTo(10.369f, 5.698f)
                lineTo(10.255f, 5.771f)
                verticalLineTo(5.908f)
                horizontalLineTo(10.505f)
                close()
                moveTo(10.505f, 6.109f)
                lineTo(10.522f, 6.359f)
                lineTo(10.755f, 6.342f)
                verticalLineTo(6.109f)
                horizontalLineTo(10.505f)
                close()
                moveTo(9.883f, 7.031f)
                horizontalLineTo(9.633f)
                verticalLineTo(7.281f)
                horizontalLineTo(9.883f)
                verticalLineTo(7.031f)
                close()
                moveTo(12.048f, 7.031f)
                verticalLineTo(7.281f)
                horizontalLineTo(12.298f)
                lineTo(12.298f, 7.032f)
                lineTo(12.048f, 7.031f)
                close()
                moveTo(10.514f, 4.821f)
                lineTo(10.485f, 4.572f)
                lineTo(9.561f, 4.68f)
                lineTo(10.414f, 5.05f)
                lineTo(10.514f, 4.821f)
                close()
                moveTo(10.957f, 4.821f)
                lineTo(11.006f, 4.576f)
                lineTo(10.853f, 4.545f)
                lineTo(10.758f, 4.67f)
                lineTo(10.957f, 4.821f)
                close()
                moveTo(11.46f, 4.711f)
                lineTo(11.682f, 4.825f)
                lineTo(11.896f, 4.409f)
                lineTo(11.431f, 4.463f)
                lineTo(11.46f, 4.711f)
                close()
                moveTo(2.5f, 7.5f)
                curveTo(2.645f, 7.704f, 2.645f, 7.704f, 2.645f, 7.704f)
                curveTo(2.645f, 7.704f, 2.645f, 7.704f, 2.645f, 7.704f)
                curveTo(2.645f, 7.704f, 2.645f, 7.703f, 2.646f, 7.703f)
                curveTo(2.646f, 7.703f, 2.646f, 7.703f, 2.647f, 7.702f)
                curveTo(2.648f, 7.702f, 2.649f, 7.701f, 2.65f, 7.7f)
                curveTo(2.652f, 7.699f, 2.655f, 7.696f, 2.658f, 7.694f)
                curveTo(2.665f, 7.688f, 2.674f, 7.681f, 2.685f, 7.672f)
                curveTo(2.707f, 7.655f, 2.735f, 7.629f, 2.768f, 7.597f)
                curveTo(2.831f, 7.533f, 2.912f, 7.437f, 2.977f, 7.312f)
                curveTo(3.042f, 7.186f, 3.091f, 7.027f, 3.084f, 6.842f)
                curveTo(3.076f, 6.655f, 3.011f, 6.46f, 2.873f, 6.263f)
                lineTo(2.463f, 6.549f)
                curveTo(2.553f, 6.677f, 2.581f, 6.782f, 2.584f, 6.862f)
                curveTo(2.587f, 6.944f, 2.566f, 7.017f, 2.532f, 7.083f)
                curveTo(2.498f, 7.15f, 2.452f, 7.205f, 2.413f, 7.245f)
                curveTo(2.394f, 7.264f, 2.377f, 7.278f, 2.367f, 7.287f)
                curveTo(2.361f, 7.292f, 2.357f, 7.295f, 2.355f, 7.296f)
                curveTo(2.354f, 7.297f, 2.354f, 7.297f, 2.354f, 7.297f)
                curveTo(2.354f, 7.297f, 2.354f, 7.297f, 2.354f, 7.297f)
                curveTo(2.354f, 7.297f, 2.355f, 7.297f, 2.355f, 7.297f)
                curveTo(2.355f, 7.296f, 2.355f, 7.296f, 2.355f, 7.296f)
                curveTo(2.355f, 7.296f, 2.355f, 7.296f, 2.355f, 7.296f)
                curveTo(2.355f, 7.296f, 2.355f, 7.296f, 2.5f, 7.5f)
                close()
                moveTo(3.028f, 6.955f)
                curveTo(2.963f, 7.091f, 2.844f, 7.166f, 2.719f, 7.208f)
                curveTo(2.657f, 7.229f, 2.599f, 7.24f, 2.557f, 7.245f)
                curveTo(2.536f, 7.248f, 2.52f, 7.249f, 2.51f, 7.25f)
                curveTo(2.505f, 7.25f, 2.501f, 7.25f, 2.5f, 7.25f)
                curveTo(2.499f, 7.25f, 2.498f, 7.25f, 2.498f, 7.25f)
                curveTo(2.498f, 7.25f, 2.499f, 7.25f, 2.499f, 7.25f)
                curveTo(2.499f, 7.25f, 2.499f, 7.25f, 2.499f, 7.25f)
                curveTo(2.499f, 7.25f, 2.5f, 7.25f, 2.5f, 7.25f)
                curveTo(2.5f, 7.25f, 2.5f, 7.25f, 2.5f, 7.25f)
                curveTo(2.5f, 7.25f, 2.5f, 7.25f, 2.5f, 7.5f)
                curveTo(2.5f, 7.75f, 2.5f, 7.75f, 2.5f, 7.75f)
                curveTo(2.5f, 7.75f, 2.5f, 7.75f, 2.5f, 7.75f)
                curveTo(2.501f, 7.75f, 2.501f, 7.75f, 2.501f, 7.75f)
                curveTo(2.501f, 7.75f, 2.502f, 7.75f, 2.502f, 7.75f)
                curveTo(2.503f, 7.75f, 2.504f, 7.75f, 2.505f, 7.75f)
                curveTo(2.507f, 7.75f, 2.51f, 7.75f, 2.513f, 7.75f)
                curveTo(2.519f, 7.75f, 2.528f, 7.749f, 2.538f, 7.749f)
                curveTo(2.558f, 7.748f, 2.586f, 7.745f, 2.62f, 7.741f)
                curveTo(2.686f, 7.733f, 2.778f, 7.716f, 2.878f, 7.682f)
                curveTo(3.078f, 7.615f, 3.335f, 7.472f, 3.479f, 7.17f)
                lineTo(3.028f, 6.955f)
                close()
                moveTo(7.712f, 6.813f)
                horizontalLineTo(3.253f)
                verticalLineTo(7.313f)
                horizontalLineTo(7.712f)
                verticalLineTo(6.813f)
                close()
                moveTo(7.462f, 6.1f)
                verticalLineTo(7.063f)
                horizontalLineTo(7.962f)
                verticalLineTo(6.1f)
                horizontalLineTo(7.462f)
                close()
                moveTo(7.222f, 5.887f)
                curveTo(7.304f, 5.887f, 7.358f, 5.929f, 7.404f, 6.002f)
                curveTo(7.428f, 6.039f, 7.444f, 6.078f, 7.455f, 6.109f)
                curveTo(7.46f, 6.124f, 7.464f, 6.136f, 7.465f, 6.144f)
                curveTo(7.466f, 6.147f, 7.467f, 6.15f, 7.467f, 6.151f)
                curveTo(7.467f, 6.151f, 7.467f, 6.151f, 7.467f, 6.151f)
                curveTo(7.467f, 6.151f, 7.467f, 6.151f, 7.467f, 6.151f)
                curveTo(7.467f, 6.15f, 7.467f, 6.15f, 7.467f, 6.15f)
                curveTo(7.467f, 6.15f, 7.467f, 6.15f, 7.467f, 6.15f)
                curveTo(7.467f, 6.15f, 7.467f, 6.15f, 7.467f, 6.15f)
                curveTo(7.467f, 6.149f, 7.467f, 6.149f, 7.712f, 6.1f)
                curveTo(7.957f, 6.05f, 7.957f, 6.05f, 7.957f, 6.05f)
                curveTo(7.957f, 6.05f, 7.957f, 6.05f, 7.957f, 6.05f)
                curveTo(7.957f, 6.05f, 7.957f, 6.05f, 7.957f, 6.05f)
                curveTo(7.957f, 6.049f, 7.957f, 6.049f, 7.957f, 6.049f)
                curveTo(7.957f, 6.048f, 7.956f, 6.047f, 7.956f, 6.046f)
                curveTo(7.956f, 6.044f, 7.955f, 6.041f, 7.955f, 6.039f)
                curveTo(7.953f, 6.033f, 7.951f, 6.025f, 7.949f, 6.016f)
                curveTo(7.944f, 5.999f, 7.937f, 5.974f, 7.928f, 5.946f)
                curveTo(7.908f, 5.89f, 7.877f, 5.814f, 7.827f, 5.735f)
                curveTo(7.728f, 5.577f, 7.537f, 5.387f, 7.222f, 5.387f)
                verticalLineTo(5.887f)
                close()
                moveTo(6.735f, 6.1f)
                curveTo(6.981f, 6.147f, 6.981f, 6.147f, 6.981f, 6.148f)
                curveTo(6.981f, 6.148f, 6.981f, 6.148f, 6.981f, 6.148f)
                curveTo(6.981f, 6.148f, 6.981f, 6.148f, 6.981f, 6.148f)
                curveTo(6.981f, 6.148f, 6.981f, 6.148f, 6.981f, 6.149f)
                curveTo(6.98f, 6.149f, 6.98f, 6.149f, 6.98f, 6.149f)
                curveTo(6.98f, 6.15f, 6.98f, 6.149f, 6.98f, 6.149f)
                curveTo(6.981f, 6.148f, 6.981f, 6.145f, 6.982f, 6.142f)
                curveTo(6.984f, 6.134f, 6.987f, 6.122f, 6.992f, 6.107f)
                curveTo(7.003f, 6.077f, 7.019f, 6.038f, 7.042f, 6.001f)
                curveTo(7.087f, 5.928f, 7.14f, 5.887f, 7.222f, 5.887f)
                verticalLineTo(5.387f)
                curveTo(6.906f, 5.387f, 6.716f, 5.578f, 6.617f, 5.737f)
                curveTo(6.568f, 5.815f, 6.537f, 5.892f, 6.519f, 5.948f)
                curveTo(6.509f, 5.976f, 6.502f, 6f, 6.498f, 6.018f)
                curveTo(6.495f, 6.027f, 6.494f, 6.035f, 6.492f, 6.041f)
                curveTo(6.492f, 6.043f, 6.491f, 6.046f, 6.491f, 6.048f)
                curveTo(6.491f, 6.049f, 6.49f, 6.05f, 6.49f, 6.05f)
                curveTo(6.49f, 6.051f, 6.49f, 6.051f, 6.49f, 6.052f)
                curveTo(6.49f, 6.052f, 6.49f, 6.052f, 6.49f, 6.052f)
                curveTo(6.49f, 6.052f, 6.49f, 6.052f, 6.49f, 6.052f)
                curveTo(6.49f, 6.052f, 6.49f, 6.052f, 6.735f, 6.1f)
                close()
                moveTo(5.167f, 6.35f)
                horizontalLineTo(6.735f)
                verticalLineTo(5.85f)
                horizontalLineTo(5.167f)
                verticalLineTo(6.35f)
                close()
                moveTo(6.519f, 4.573f)
                lineTo(5.002f, 5.912f)
                lineTo(5.333f, 6.287f)
                lineTo(6.85f, 4.948f)
                lineTo(6.519f, 4.573f)
                close()
                moveTo(6.224f, 4.687f)
                lineTo(6.519f, 4.948f)
                lineTo(6.85f, 4.573f)
                lineTo(6.555f, 4.313f)
                lineTo(6.224f, 4.687f)
                close()
                moveTo(4.869f, 6.175f)
                lineTo(6.555f, 4.687f)
                lineTo(6.224f, 4.313f)
                lineTo(4.539f, 5.8f)
                lineTo(4.869f, 6.175f)
                close()
                moveTo(4.954f, 6.303f)
                verticalLineTo(5.988f)
                horizontalLineTo(4.454f)
                verticalLineTo(6.303f)
                horizontalLineTo(4.954f)
                close()
                moveTo(7.097f, 6.053f)
                horizontalLineTo(4.704f)
                verticalLineTo(6.553f)
                horizontalLineTo(7.097f)
                verticalLineTo(6.053f)
                close()
                moveTo(6.847f, 6.118f)
                verticalLineTo(6.303f)
                horizontalLineTo(7.347f)
                verticalLineTo(6.118f)
                horizontalLineTo(6.847f)
                close()
                moveTo(7.222f, 5.76f)
                curveTo(7.068f, 5.76f, 6.963f, 5.842f, 6.907f, 5.928f)
                curveTo(6.882f, 5.967f, 6.869f, 6.003f, 6.861f, 6.029f)
                curveTo(6.857f, 6.043f, 6.854f, 6.055f, 6.852f, 6.064f)
                curveTo(6.851f, 6.069f, 6.85f, 6.073f, 6.85f, 6.077f)
                curveTo(6.85f, 6.079f, 6.849f, 6.081f, 6.849f, 6.082f)
                curveTo(6.849f, 6.083f, 6.849f, 6.084f, 6.849f, 6.084f)
                curveTo(6.849f, 6.085f, 6.849f, 6.085f, 6.849f, 6.086f)
                curveTo(6.849f, 6.086f, 6.849f, 6.086f, 6.849f, 6.086f)
                curveTo(6.849f, 6.086f, 6.849f, 6.086f, 6.849f, 6.086f)
                curveTo(6.849f, 6.086f, 6.848f, 6.087f, 7.097f, 6.118f)
                curveTo(7.345f, 6.149f, 7.345f, 6.149f, 7.345f, 6.149f)
                curveTo(7.345f, 6.149f, 7.345f, 6.149f, 7.345f, 6.149f)
                curveTo(7.345f, 6.149f, 7.345f, 6.149f, 7.345f, 6.15f)
                curveTo(7.344f, 6.15f, 7.344f, 6.15f, 7.344f, 6.15f)
                curveTo(7.344f, 6.151f, 7.344f, 6.152f, 7.344f, 6.152f)
                curveTo(7.344f, 6.154f, 7.344f, 6.155f, 7.344f, 6.156f)
                curveTo(7.343f, 6.158f, 7.343f, 6.16f, 7.343f, 6.162f)
                curveTo(7.342f, 6.165f, 7.341f, 6.169f, 7.34f, 6.172f)
                curveTo(7.338f, 6.178f, 7.335f, 6.188f, 7.327f, 6.199f)
                curveTo(7.319f, 6.212f, 7.305f, 6.228f, 7.283f, 6.242f)
                curveTo(7.259f, 6.256f, 7.236f, 6.26f, 7.222f, 6.26f)
                verticalLineTo(5.76f)
                close()
                moveTo(7.306f, 6.118f)
                curveTo(7.549f, 6.179f, 7.549f, 6.179f, 7.549f, 6.179f)
                curveTo(7.549f, 6.179f, 7.549f, 6.179f, 7.549f, 6.178f)
                curveTo(7.549f, 6.178f, 7.549f, 6.178f, 7.549f, 6.178f)
                curveTo(7.549f, 6.178f, 7.549f, 6.177f, 7.549f, 6.177f)
                curveTo(7.549f, 6.176f, 7.55f, 6.176f, 7.55f, 6.175f)
                curveTo(7.55f, 6.173f, 7.55f, 6.172f, 7.551f, 6.17f)
                curveTo(7.552f, 6.166f, 7.553f, 6.162f, 7.553f, 6.157f)
                curveTo(7.555f, 6.147f, 7.557f, 6.135f, 7.558f, 6.121f)
                curveTo(7.56f, 6.094f, 7.561f, 6.05f, 7.548f, 5.999f)
                curveTo(7.533f, 5.947f, 7.501f, 5.88f, 7.434f, 5.828f)
                curveTo(7.367f, 5.777f, 7.29f, 5.76f, 7.222f, 5.76f)
                verticalLineTo(6.26f)
                curveTo(7.209f, 6.26f, 7.171f, 6.257f, 7.13f, 6.225f)
                curveTo(7.089f, 6.194f, 7.071f, 6.154f, 7.064f, 6.128f)
                curveTo(7.058f, 6.105f, 7.059f, 6.087f, 7.06f, 6.081f)
                curveTo(7.06f, 6.077f, 7.061f, 6.073f, 7.061f, 6.069f)
                curveTo(7.062f, 6.067f, 7.062f, 6.065f, 7.062f, 6.063f)
                curveTo(7.063f, 6.062f, 7.063f, 6.061f, 7.063f, 6.06f)
                curveTo(7.063f, 6.059f, 7.063f, 6.059f, 7.064f, 6.058f)
                curveTo(7.064f, 6.058f, 7.064f, 6.057f, 7.064f, 6.057f)
                curveTo(7.064f, 6.057f, 7.064f, 6.057f, 7.064f, 6.057f)
                curveTo(7.064f, 6.057f, 7.064f, 6.056f, 7.064f, 6.056f)
                curveTo(7.064f, 6.056f, 7.064f, 6.056f, 7.306f, 6.118f)
                close()
                moveTo(7.556f, 6.514f)
                verticalLineTo(6.118f)
                horizontalLineTo(7.056f)
                verticalLineTo(6.514f)
                horizontalLineTo(7.556f)
                close()
                moveTo(4.291f, 6.764f)
                horizontalLineTo(7.306f)
                verticalLineTo(6.264f)
                horizontalLineTo(4.291f)
                verticalLineTo(6.764f)
                close()
                moveTo(4.041f, 5.972f)
                verticalLineTo(6.514f)
                horizontalLineTo(4.541f)
                verticalLineTo(5.972f)
                horizontalLineTo(4.041f)
                close()
                moveTo(4.067f, 6.346f)
                lineTo(4.393f, 6.2f)
                lineTo(4.189f, 5.744f)
                lineTo(3.863f, 5.889f)
                lineTo(4.067f, 6.346f)
                close()
                moveTo(4.215f, 6.514f)
                verticalLineTo(6.118f)
                horizontalLineTo(3.715f)
                verticalLineTo(6.514f)
                horizontalLineTo(4.215f)
                close()
                moveTo(3.312f, 6.656f)
                curveTo(3.412f, 6.656f, 3.554f, 6.678f, 3.683f, 6.705f)
                curveTo(3.745f, 6.718f, 3.8f, 6.73f, 3.839f, 6.74f)
                curveTo(3.858f, 6.745f, 3.874f, 6.749f, 3.884f, 6.751f)
                curveTo(3.89f, 6.753f, 3.893f, 6.754f, 3.896f, 6.755f)
                curveTo(3.897f, 6.755f, 3.898f, 6.755f, 3.899f, 6.755f)
                curveTo(3.899f, 6.755f, 3.899f, 6.755f, 3.899f, 6.755f)
                curveTo(3.899f, 6.755f, 3.899f, 6.755f, 3.899f, 6.755f)
                curveTo(3.899f, 6.755f, 3.899f, 6.755f, 3.899f, 6.755f)
                curveTo(3.899f, 6.755f, 3.899f, 6.755f, 3.899f, 6.755f)
                curveTo(3.899f, 6.755f, 3.899f, 6.755f, 3.965f, 6.514f)
                curveTo(4.03f, 6.273f, 4.03f, 6.273f, 4.03f, 6.273f)
                curveTo(4.03f, 6.273f, 4.03f, 6.273f, 4.03f, 6.273f)
                curveTo(4.03f, 6.273f, 4.03f, 6.273f, 4.03f, 6.273f)
                curveTo(4.03f, 6.273f, 4.03f, 6.273f, 4.03f, 6.273f)
                curveTo(4.029f, 6.273f, 4.029f, 6.273f, 4.029f, 6.272f)
                curveTo(4.028f, 6.272f, 4.026f, 6.272f, 4.025f, 6.271f)
                curveTo(4.021f, 6.27f, 4.016f, 6.269f, 4.01f, 6.268f)
                curveTo(3.998f, 6.264f, 3.98f, 6.26f, 3.958f, 6.254f)
                curveTo(3.914f, 6.244f, 3.853f, 6.229f, 3.784f, 6.215f)
                curveTo(3.65f, 6.187f, 3.466f, 6.156f, 3.312f, 6.156f)
                verticalLineTo(6.656f)
                close()
                moveTo(3.045f, 6.118f)
                curveTo(2.795f, 6.13f, 2.795f, 6.131f, 2.795f, 6.131f)
                curveTo(2.795f, 6.131f, 2.795f, 6.131f, 2.795f, 6.131f)
                curveTo(2.795f, 6.131f, 2.795f, 6.131f, 2.795f, 6.131f)
                curveTo(2.795f, 6.132f, 2.795f, 6.132f, 2.795f, 6.132f)
                curveTo(2.795f, 6.133f, 2.795f, 6.134f, 2.795f, 6.135f)
                curveTo(2.795f, 6.137f, 2.796f, 6.139f, 2.796f, 6.141f)
                curveTo(2.796f, 6.146f, 2.797f, 6.152f, 2.797f, 6.158f)
                curveTo(2.799f, 6.172f, 2.802f, 6.19f, 2.806f, 6.211f)
                curveTo(2.814f, 6.252f, 2.829f, 6.31f, 2.859f, 6.372f)
                curveTo(2.923f, 6.502f, 3.063f, 6.656f, 3.312f, 6.656f)
                verticalLineTo(6.156f)
                curveTo(3.3f, 6.156f, 3.304f, 6.153f, 3.311f, 6.159f)
                curveTo(3.316f, 6.162f, 3.313f, 6.162f, 3.308f, 6.152f)
                curveTo(3.303f, 6.141f, 3.299f, 6.127f, 3.296f, 6.114f)
                curveTo(3.295f, 6.108f, 3.295f, 6.104f, 3.294f, 6.102f)
                curveTo(3.294f, 6.101f, 3.294f, 6.1f, 3.294f, 6.101f)
                curveTo(3.294f, 6.101f, 3.294f, 6.101f, 3.294f, 6.102f)
                curveTo(3.294f, 6.102f, 3.294f, 6.103f, 3.294f, 6.103f)
                curveTo(3.294f, 6.103f, 3.294f, 6.104f, 3.294f, 6.104f)
                curveTo(3.294f, 6.104f, 3.294f, 6.104f, 3.294f, 6.104f)
                curveTo(3.294f, 6.104f, 3.294f, 6.104f, 3.294f, 6.104f)
                curveTo(3.294f, 6.105f, 3.294f, 6.105f, 3.045f, 6.118f)
                close()
                moveTo(2.82f, 6.604f)
                lineTo(3.197f, 6.316f)
                lineTo(2.893f, 5.919f)
                lineTo(2.516f, 6.207f)
                lineTo(2.82f, 6.604f)
                close()
                moveTo(9.2f, 6.958f)
                lineTo(8.955f, 6.349f)
                lineTo(8.491f, 6.536f)
                lineTo(8.736f, 7.145f)
                lineTo(9.2f, 6.958f)
                close()
                moveTo(7.995f, 7.302f)
                horizontalLineTo(8.968f)
                verticalLineTo(6.802f)
                horizontalLineTo(7.995f)
                verticalLineTo(7.302f)
                close()
                moveTo(7.745f, 4.607f)
                verticalLineTo(7.052f)
                horizontalLineTo(8.245f)
                verticalLineTo(4.607f)
                horizontalLineTo(7.745f)
                close()
                moveTo(8.481f, 4.5f)
                lineTo(8.071f, 4.369f)
                lineTo(7.919f, 4.845f)
                lineTo(8.329f, 4.977f)
                lineTo(8.481f, 4.5f)
                close()
                moveTo(8.655f, 6.443f)
                verticalLineTo(4.739f)
                horizontalLineTo(8.155f)
                verticalLineTo(6.443f)
                horizontalLineTo(8.655f)
                close()
                moveTo(8.723f, 6.193f)
                horizontalLineTo(8.405f)
                verticalLineTo(6.693f)
                horizontalLineTo(8.723f)
                verticalLineTo(6.193f)
                close()
                moveTo(13.732f, 6.958f)
                lineTo(13.488f, 6.349f)
                lineTo(13.024f, 6.536f)
                lineTo(13.268f, 7.145f)
                lineTo(13.732f, 6.958f)
                close()
                moveTo(12.527f, 7.302f)
                horizontalLineTo(13.5f)
                verticalLineTo(6.802f)
                horizontalLineTo(12.527f)
                verticalLineTo(7.302f)
                close()
                moveTo(12.277f, 4.607f)
                verticalLineTo(7.052f)
                horizontalLineTo(12.777f)
                verticalLineTo(4.607f)
                horizontalLineTo(12.277f)
                close()
                moveTo(13.014f, 4.5f)
                lineTo(12.603f, 4.369f)
                lineTo(12.451f, 4.845f)
                lineTo(12.861f, 4.977f)
                lineTo(13.014f, 4.5f)
                close()
                moveTo(13.187f, 6.443f)
                verticalLineTo(4.739f)
                horizontalLineTo(12.687f)
                verticalLineTo(6.443f)
                horizontalLineTo(13.187f)
                close()
                moveTo(13.255f, 6.193f)
                horizontalLineTo(12.937f)
                verticalLineTo(6.693f)
                horizontalLineTo(13.255f)
                verticalLineTo(6.193f)
                close()
                moveTo(11.937f, 5.011f)
                lineTo(12.191f, 4.84f)
                lineTo(11.911f, 4.425f)
                lineTo(11.657f, 4.597f)
                lineTo(11.937f, 5.011f)
                close()
                moveTo(12.047f, 6.441f)
                verticalLineTo(4.804f)
                horizontalLineTo(11.547f)
                verticalLineTo(6.441f)
                horizontalLineTo(12.047f)
                close()
                moveTo(11.539f, 6.691f)
                horizontalLineTo(11.797f)
                verticalLineTo(6.191f)
                horizontalLineTo(11.539f)
                verticalLineTo(6.691f)
                close()
                moveTo(11.289f, 5.128f)
                verticalLineTo(6.441f)
                horizontalLineTo(11.789f)
                verticalLineTo(5.128f)
                horizontalLineTo(11.289f)
                close()
                moveTo(11.238f, 5.59f)
                lineTo(11.664f, 5.345f)
                lineTo(11.414f, 4.912f)
                lineTo(10.989f, 5.157f)
                lineTo(11.238f, 5.59f)
                close()
                moveTo(11.364f, 6.441f)
                verticalLineTo(5.373f)
                horizontalLineTo(10.864f)
                verticalLineTo(6.441f)
                horizontalLineTo(11.364f)
                close()
                moveTo(10.828f, 6.691f)
                horizontalLineTo(11.114f)
                verticalLineTo(6.191f)
                horizontalLineTo(10.828f)
                verticalLineTo(6.691f)
                close()
                moveTo(10.578f, 5.7f)
                verticalLineTo(6.441f)
                horizontalLineTo(11.078f)
                verticalLineTo(5.7f)
                horizontalLineTo(10.578f)
                close()
                moveTo(10.64f, 6.118f)
                lineTo(10.963f, 5.91f)
                lineTo(10.693f, 5.49f)
                lineTo(10.369f, 5.698f)
                lineTo(10.64f, 6.118f)
                close()
                moveTo(10.755f, 6.109f)
                verticalLineTo(5.908f)
                horizontalLineTo(10.255f)
                verticalLineTo(6.109f)
                horizontalLineTo(10.755f)
                close()
                moveTo(10.133f, 7.031f)
                curveTo(10.133f, 6.659f, 10.26f, 6.505f, 10.347f, 6.438f)
                curveTo(10.396f, 6.4f, 10.444f, 6.38f, 10.48f, 6.369f)
                curveTo(10.498f, 6.363f, 10.512f, 6.36f, 10.52f, 6.359f)
                curveTo(10.524f, 6.358f, 10.526f, 6.358f, 10.526f, 6.358f)
                curveTo(10.527f, 6.358f, 10.526f, 6.358f, 10.526f, 6.358f)
                curveTo(10.525f, 6.358f, 10.525f, 6.358f, 10.524f, 6.358f)
                curveTo(10.524f, 6.358f, 10.524f, 6.358f, 10.523f, 6.358f)
                curveTo(10.523f, 6.358f, 10.523f, 6.358f, 10.523f, 6.358f)
                curveTo(10.523f, 6.358f, 10.522f, 6.358f, 10.522f, 6.358f)
                curveTo(10.522f, 6.359f, 10.522f, 6.359f, 10.505f, 6.109f)
                curveTo(10.488f, 5.86f, 10.487f, 5.86f, 10.487f, 5.86f)
                curveTo(10.487f, 5.86f, 10.487f, 5.86f, 10.487f, 5.86f)
                curveTo(10.486f, 5.86f, 10.486f, 5.86f, 10.486f, 5.86f)
                curveTo(10.486f, 5.86f, 10.485f, 5.86f, 10.484f, 5.86f)
                curveTo(10.483f, 5.86f, 10.482f, 5.86f, 10.48f, 5.86f)
                curveTo(10.477f, 5.861f, 10.473f, 5.861f, 10.469f, 5.861f)
                curveTo(10.46f, 5.862f, 10.449f, 5.864f, 10.436f, 5.866f)
                curveTo(10.41f, 5.871f, 10.375f, 5.878f, 10.335f, 5.89f)
                curveTo(10.254f, 5.915f, 10.147f, 5.96f, 10.04f, 6.043f)
                curveTo(9.816f, 6.217f, 9.633f, 6.525f, 9.633f, 7.031f)
                horizontalLineTo(10.133f)
                close()
                moveTo(12.048f, 6.781f)
                horizontalLineTo(9.883f)
                verticalLineTo(7.281f)
                horizontalLineTo(12.048f)
                verticalLineTo(6.781f)
                close()
                moveTo(11.801f, 4.632f)
                lineTo(11.798f, 7.031f)
                lineTo(12.298f, 7.032f)
                lineTo(12.301f, 4.633f)
                lineTo(11.801f, 4.632f)
                close()
                moveTo(3.638f, 7.358f)
                curveTo(3.638f, 7.312f, 3.659f, 7.278f, 3.681f, 7.259f)
                curveTo(3.702f, 7.24f, 3.726f, 7.233f, 3.746f, 7.233f)
                verticalLineTo(7.733f)
                curveTo(3.932f, 7.733f, 4.138f, 7.593f, 4.138f, 7.358f)
                horizontalLineTo(3.638f)
                close()
                moveTo(3.746f, 7.483f)
                curveTo(3.726f, 7.483f, 3.702f, 7.476f, 3.681f, 7.457f)
                curveTo(3.659f, 7.438f, 3.638f, 7.403f, 3.638f, 7.358f)
                horizontalLineTo(4.138f)
                curveTo(4.138f, 7.122f, 3.932f, 6.983f, 3.746f, 6.983f)
                verticalLineTo(7.483f)
                close()
                moveTo(3.854f, 7.358f)
                curveTo(3.854f, 7.403f, 3.833f, 7.438f, 3.811f, 7.457f)
                curveTo(3.79f, 7.476f, 3.766f, 7.483f, 3.746f, 7.483f)
                verticalLineTo(6.983f)
                curveTo(3.56f, 6.983f, 3.354f, 7.122f, 3.354f, 7.358f)
                horizontalLineTo(3.854f)
                close()
                moveTo(3.746f, 7.233f)
                curveTo(3.766f, 7.233f, 3.79f, 7.24f, 3.811f, 7.259f)
                curveTo(3.833f, 7.278f, 3.854f, 7.312f, 3.854f, 7.358f)
                horizontalLineTo(3.354f)
                curveTo(3.354f, 7.593f, 3.56f, 7.733f, 3.746f, 7.733f)
                verticalLineTo(7.233f)
                close()
                moveTo(10.514f, 4.821f)
                curveTo(10.414f, 5.05f, 10.414f, 5.05f, 10.414f, 5.05f)
                curveTo(10.414f, 5.05f, 10.414f, 5.05f, 10.414f, 5.05f)
                curveTo(10.414f, 5.05f, 10.414f, 5.05f, 10.415f, 5.05f)
                curveTo(10.415f, 5.05f, 10.415f, 5.051f, 10.415f, 5.051f)
                curveTo(10.416f, 5.051f, 10.416f, 5.051f, 10.417f, 5.051f)
                curveTo(10.418f, 5.052f, 10.42f, 5.053f, 10.422f, 5.053f)
                curveTo(10.425f, 5.055f, 10.43f, 5.057f, 10.436f, 5.059f)
                curveTo(10.449f, 5.064f, 10.466f, 5.071f, 10.486f, 5.078f)
                curveTo(10.526f, 5.091f, 10.584f, 5.109f, 10.648f, 5.121f)
                curveTo(10.71f, 5.133f, 10.793f, 5.142f, 10.877f, 5.129f)
                curveTo(10.964f, 5.117f, 11.076f, 5.078f, 11.156f, 4.972f)
                lineTo(10.758f, 4.67f)
                curveTo(10.783f, 4.636f, 10.813f, 4.634f, 10.806f, 4.635f)
                curveTo(10.797f, 4.636f, 10.775f, 4.636f, 10.74f, 4.629f)
                curveTo(10.707f, 4.623f, 10.674f, 4.614f, 10.649f, 4.605f)
                curveTo(10.636f, 4.6f, 10.626f, 4.597f, 10.62f, 4.594f)
                curveTo(10.617f, 4.593f, 10.614f, 4.592f, 10.613f, 4.592f)
                curveTo(10.613f, 4.591f, 10.612f, 4.591f, 10.612f, 4.591f)
                curveTo(10.612f, 4.591f, 10.612f, 4.591f, 10.613f, 4.591f)
                curveTo(10.613f, 4.591f, 10.613f, 4.591f, 10.613f, 4.591f)
                curveTo(10.613f, 4.591f, 10.613f, 4.591f, 10.613f, 4.591f)
                curveTo(10.613f, 4.591f, 10.613f, 4.591f, 10.613f, 4.591f)
                curveTo(10.613f, 4.591f, 10.613f, 4.592f, 10.514f, 4.821f)
                close()
                moveTo(11.431f, 4.463f)
                lineTo(10.485f, 4.572f)
                lineTo(10.542f, 5.069f)
                lineTo(11.489f, 4.96f)
                lineTo(11.431f, 4.463f)
                close()
                moveTo(10.957f, 4.821f)
                curveTo(10.908f, 5.066f, 10.908f, 5.066f, 10.908f, 5.066f)
                curveTo(10.908f, 5.066f, 10.908f, 5.066f, 10.908f, 5.066f)
                curveTo(10.908f, 5.066f, 10.909f, 5.066f, 10.909f, 5.066f)
                curveTo(10.909f, 5.066f, 10.909f, 5.066f, 10.909f, 5.066f)
                curveTo(10.91f, 5.066f, 10.91f, 5.066f, 10.911f, 5.067f)
                curveTo(10.913f, 5.067f, 10.915f, 5.067f, 10.917f, 5.068f)
                curveTo(10.921f, 5.068f, 10.927f, 5.069f, 10.934f, 5.071f)
                curveTo(10.949f, 5.073f, 10.969f, 5.076f, 10.993f, 5.079f)
                curveTo(11.04f, 5.084f, 11.107f, 5.09f, 11.18f, 5.087f)
                curveTo(11.25f, 5.085f, 11.34f, 5.075f, 11.427f, 5.043f)
                curveTo(11.516f, 5.01f, 11.62f, 4.946f, 11.682f, 4.825f)
                lineTo(11.237f, 4.597f)
                curveTo(11.251f, 4.571f, 11.268f, 4.569f, 11.253f, 4.574f)
                curveTo(11.237f, 4.581f, 11.207f, 4.586f, 11.164f, 4.588f)
                curveTo(11.123f, 4.589f, 11.083f, 4.586f, 11.051f, 4.582f)
                curveTo(11.036f, 4.58f, 11.023f, 4.579f, 11.015f, 4.577f)
                curveTo(11.011f, 4.577f, 11.008f, 4.576f, 11.007f, 4.576f)
                curveTo(11.006f, 4.576f, 11.006f, 4.576f, 11.006f, 4.576f)
                curveTo(11.005f, 4.576f, 11.006f, 4.576f, 11.006f, 4.576f)
                curveTo(11.006f, 4.576f, 11.006f, 4.576f, 11.006f, 4.576f)
                curveTo(11.006f, 4.576f, 11.006f, 4.576f, 11.006f, 4.576f)
                curveTo(11.006f, 4.576f, 11.006f, 4.576f, 11.006f, 4.576f)
                curveTo(11.006f, 4.576f, 11.006f, 4.576f, 10.957f, 4.821f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun IraqPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Iraq,
            contentDescription = "Iraq Flag"
        )
    }
}
